'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactI18next = require('react-i18next');

var _CheckboxField = require('components/formComponents/CheckboxField');

var _CheckboxField2 = _interopRequireDefault(_CheckboxField);

var _auth = require('selectors/auth');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var WatermarkField = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    permissions: (0, _auth.getPermissions)(state)
  };
}), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(WatermarkField, _Component);

  function WatermarkField() {
    (0, _classCallCheck3.default)(this, WatermarkField);
    return (0, _possibleConstructorReturn3.default)(this, (WatermarkField.__proto__ || (0, _getPrototypeOf2.default)(WatermarkField)).apply(this, arguments));
  }

  (0, _createClass3.default)(WatermarkField, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          permissions = _props.permissions,
          className = _props.className;


      return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('inline-block', className) },
        _react2.default.createElement(_CheckboxField2.default, {
          name: 'directAccessWatermark',
          small: true,
          type: 'checkbox',
          textBefore: t('No Password'),
          disabled: !permissions.noPasswordFeature
        })
      );
    }
  }]);
  return WatermarkField;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  permissions: _propTypes2.default.object,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  permissions: {}
}, _temp)) || _class) || _class);
exports.default = WatermarkField;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/form/WatermarkField.js
// module id = 842
// module chunks = 1